import { produce } from "immer";
import {
  ADD_DISPLAY_FAILED,
  ADD_DISPLAY_REQUEST,
  ADD_DISPLAY_SUCCESS,
  ADD_LIBRARY_FAILED,
  ADD_LIBRARY_REQUEST,
  ADD_LIBRARY_SUCCESS,
  DELETE_DISPLAY,
  DELETE_DISPLAY_FAILURE,
  DELETE_DISPLAY_SUCCESS,
  DELETE_FAILED,
  DELETE_IMAGE,
  DELETE_SUCCESS,
  GET_DISPLAY_FAILED,
  GET_DISPLAY_REQUEST,
  GET_DISPLAY_SUCCESS,
  GET_LIBRARY_FAILED,
  GET_LIBRARY_REQUEST,
  GET_LIBRARY_SUCCESS,
  TEMPLATE_FAILED,
  TEMPLATE_REQUEST,
  TEMPLATE_SUCCESS,
  UPLOAD_FAILED,
  UPLOAD_IMAGE,
  UPLOAD_INDEX,
  UPLOAD_SUCCESS,
} from "./DisplayConstant";
 
const initialProductCatalogState = {
  getLibrary: [],
  getLibraryLoading: false,
  getLibrarySuccess: false,
  getLibraryFailed: false,
 
  getDisplay: [],
  getDisplayLoading: false,
  getDisplaySuccess: false,
  getDisplayFailed: false,
 
  AddDisplay: [],
  AddDisplayLoading: true,
  AddDisplaySuccess: false,
  AddDisplayFailed: false,
 
  uploadIndex:-1,
 
  uploadImageLoading: false,
  uploadImageSuccess: false,
  uploadImageFailed: false,
  deleteImageLoading: false,
  deleteImageSuccess: false,
  deleteImageFailure: false,
 
  deleteDisplayLoading: false,
  deleteDisplaySuccess: false,
  deleteDisplayFailure: false,
 
  templatedataLoading:false,
  templateSuccess:[],
  templateFailed:false
};
 
export default function DisplayReducer(
  state = initialProductCatalogState,
  action
) {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_LIBRARY_REQUEST:
        draft.getLibrary = [];
 
        draft.getLibraryLoading = true;
        draft.getLibrarySuccess = false;
        draft.getLibraryFailed = false;
        break;
      case GET_LIBRARY_SUCCESS:
        draft.getLibrary = action.payload;
        draft.getLibrarySuccess = true;
        draft.getLibraryFailed = false;
        draft.getLibraryLoading = false;
        break;
      case GET_LIBRARY_FAILED:
        draft.getLibrary = [];
        draft.getLibraryLoading = false;
        draft.getLibraryFailed = true;
        draft.getLibrarySuccess = false;
        break;
 
      case GET_DISPLAY_REQUEST:
        draft.getDisplay = [];

 
        draft.getDisplayLoading = true;
        draft.getDisplaySuccess = false;
        draft.getDisplayFailed = false;
        break;
      case GET_DISPLAY_SUCCESS:
        draft.getDisplay = action.payload;
        draft.getDisplaySuccess = true;
        draft.getDisplayFailed = false;
        draft.getDisplayLoading = false;
        break;
      case GET_DISPLAY_FAILED:
        draft.getDisplay = [];
        draft.getDisplayLoading = false;
        draft.getDisplayFailed = true;
        draft.getDisplaySuccess = false;
        break;
 
      case ADD_DISPLAY_REQUEST:
        draft.AddDisplay = [];
 
        draft.AddDisplayLoading = true;
        draft.AddDisplaySuccess = false;
        draft.AddDisplayFailed = false;
        break;
      case ADD_DISPLAY_SUCCESS:
        draft.AddDisplay = action.payload;
        draft.AddDisplaySuccess = true;
        draft.AddDisplayFailed = false;
        draft.AddDisplayLoading = false;
        break;
      case ADD_DISPLAY_FAILED:
        draft.AddDisplay = [];
        draft.AddDisplayLoading = false;
        draft.AddDisplayFailed = true;
        draft.AddDisplaySuccess = false;
        break;
 
      case UPLOAD_IMAGE:
        draft.uploadImageLoading = true;
        draft.uploadImageSuccess = false;
        draft.uploadImageFailed = false;
        draft.uploadIndex=action.payload.index;
        break;
      case UPLOAD_SUCCESS:
        draft.uploadImageLoading = false;
        draft.uploadImageSuccess = true;
        draft.uploadImageFailed = false;
        break;
        case UPLOAD_INDEX:
        draft.uploadIndex=action.payload.index
        break;
      case UPLOAD_FAILED:
        draft.uploadImageLoading = false;
        draft.uploadImageSuccess = false;
        draft.uploadImageFailed = true;
        break;
      case DELETE_IMAGE:
        draft.deleteImageLoading = true;
        draft.deleteImageSuccess = false;
        draft.deleteImageFailure = false;
        break;
      case DELETE_SUCCESS:
        draft.deleteImageLoading = false;
        draft.deleteImageSuccess = true;
        draft.deleteImageFailure = false;
        break;
      case DELETE_FAILED:
        draft.deleteImageLoading = false;
        draft.deleteImageSuccess = false;
        draft.deleteImageFailure = true;
        break;
        case DELETE_DISPLAY:
          draft.deleteDisplayLoading = true;
          draft.deleteDisplaySuccess = false;
          draft.deleteDisplayFailure = false;
          break;
        case DELETE_DISPLAY_SUCCESS:
          draft.deleteDisplayLoading = false;
          draft.deleteDisplaySuccess = true;
          draft.deleteDisplayFailure = false;
          break;
        case DELETE_DISPLAY_FAILURE:
          draft.deleteDisplayLoading = false;
          draft.deleteDisplaySuccess = false;
          draft.deleteDisplayFailure = true;
          break;
 
          case TEMPLATE_REQUEST:
          draft.templatedataLoading = true;
          draft.templateSuccess = [];
          draft.templateFailed = false;
          break;
        case TEMPLATE_SUCCESS:
          draft.templatedataLoading = false;
          draft.templateSuccess = action.payload;
          draft.templateFailed = false;
          break;
        case TEMPLATE_FAILED:
          draft.templatedataLoading = false;
          draft.templateSuccess = [];
          draft.templateFailed = true;
          break;
 
      default:
    }
  });
}